export default __webpack_public_path__ + "static/media/chip_500.45cffbf7.svg";